<ion-header>
  <ion-toolbar>
    <ion-title class="j-title" translate>usersDetail.title</ion-title>
    <ion-buttons slot="end">
      <ion-button color="primary" button (click)="close()" routerDirection="root" translate>usersDetail.cancel</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="modal-content scroll">
    <div class="sub-card">
      <div class="loh h-sb v-center" *ngIf="loading">
        <ion-row class="full-width picture ml">
          <div class="pt pl flex-center">
            <ion-skeleton-text animated class="resize-img loading-picture"></ion-skeleton-text>
          </div>
        </ion-row>

        <ion-row class="full-width full-height lov h-left h-sb pt pb">
          <div class="div-details pt pb pr">
            <ion-label class="label-details" translate>
              common.name<ion-skeleton-text style="width: 50%" animated></ion-skeleton-text>
            </ion-label>
            <ion-label class="label-details" translate>
              common.email<ion-skeleton-text style="width: 70%" animated></ion-skeleton-text>
            </ion-label>
            <ion-label class="label-details" translate>
              common.office<ion-skeleton-text style="width: 60%" animated></ion-skeleton-text>
            </ion-label>
            <ion-label class="label-details" translate>
              common.departament<ion-skeleton-text style="width: 80%" animated></ion-skeleton-text>
            </ion-label>
          </div>

          <div class="pt pb pl lov h-center v-bottom">
            <ion-skeleton-text animated class="logo"></ion-skeleton-text>
          </div>
        </ion-row>
      </div>

      <div class="user-data" *ngIf="!loading">
        <ion-row class="user-container picture">
          <div class="user-image">
            <img [src]="user.picture ? user.picture : '../../../../../assets/images/user.png'" class="resize-img" aria-hidden="true" />
          </div>
        </ion-row>

        <ion-row class="user-infos">
          <div class="div-details details-infos">
            <ion-label class="label-details" translate
              >common.name<span> {{ user.name }}</span>
            </ion-label>

            <ion-label class="label-details" *ngIf="user.email" translate
              >common.email<span> {{ user.email }}</span>
            </ion-label>

            <ion-label class="label-details" translate
              >common.office<span>
                {{ user.jobDescriptionSap | i18n }}
              </span>
            </ion-label>

            <ion-label class="label-details" translate
              >common.departament<span>
                {{ user.departamentDescriptionSap | i18n }}
              </span>
            </ion-label>
          </div>

          <div class="pt pl lov h-center v-bottom">
            <ion-img
              [src]="user.businessUnitImage ? user.businessUnitImage : '../../../../../assets/icon/grupo-jacto-logo-black.svg'"
              class="logo"
              aria-hidden="true"></ion-img>
          </div>
        </ion-row>
      </div>

      <div class="bottom" *ngIf="!loading">
        <div class="loh pl">
          <div aria-expanded="false" class="button configs-language m" translate>panel.label.config.language</div>
          <ion-select
            class="langSelect"
            name="applications"
            [(ngModel)]="selectedLanguage"
            interface="popover"
            (ionChange)="changeLang()"
            [(ngModel)]="selectedLanguage">
            <ion-select-option *ngFor="let language of languages" [value]="language.iso" class="scroll" translate>
              {{ language.translate }}
            </ion-select-option>
          </ion-select>
        </div>

        <div class="pl v-center sso-login" style="margin-top: -10px" *ngIf="canToggleSso">
          <div *ngIf="ssoEnabled">
            <span class="sso-label" translate>sso.login: </span>
            <span style="margin-left: 5px">{{ user.ssoEmail || '-' }}</span>
          </div>
        </div>

        <div class="lov center buttons">
          <ion-button
            class="j-button profile-button outline bold"
            type="button"
            fill="outline"
            translate
            (click)="email()"
            *ngIf="!changePass"
            >usersDetail.button.generateSignature
          </ion-button>
        </div>
      </div>

      <div class="sub-card" *ngIf="changePass">
        <div class="lov m">
          <ion-row class="flex-center full-width">
            <ion-item class="full-width">
              <ion-label position="floating" translate>common.currentPassword</ion-label>
              <ion-input
                autocomplete="off"
                [type]="showCurrentPassword === true ? 'text' : 'password'"
                clear-on-edit="false"
                [(ngModel)]="currentPassword">
              </ion-input>
              <ion-icon
                [name]="showCurrentPassword ? 'eye' : 'eye-off'"
                class="eye-icon"
                color="medium"
                (click)="showCurrentPassword = !showCurrentPassword"></ion-icon>
            </ion-item>
          </ion-row>
          <ion-item class="full-width">
            <ion-label position="floating" translate>common.newPassword</ion-label>
            <ion-input
              autocomplete="off"
              [type]="showNewPassword ? 'text' : 'password'"
              (ionChange)="checkPassword()"
              [(ngModel)]="newPassword"
              clear-on-edit="false">
            </ion-input>

            <ion-icon
              [name]="showNewPassword === true ? 'eye' : 'eye-off'"
              class="eye-icon"
              color="medium"
              (click)="showNewPassword = !showNewPassword"></ion-icon>
          </ion-item>

          <ion-row class="flex-center full-width">
            <ion-col class="p">
              <ion-label [color]="uppercase ? 'success' : 'danger'" class="error-input" translate> common.passwordUppercase </ion-label>
            </ion-col>
            <ion-col class="p">
              <ion-label [color]="characterSpecial ? 'success' : 'danger'" class="error-input" translate>
                common.passwordCharacterSpecial
              </ion-label>
            </ion-col>
          </ion-row>

          <ion-row class="flex-center full-width">
            <ion-col class="p">
              <ion-label [color]="characterNumbers ? 'success' : 'danger'" class="error-input" translate>
                common.passwordNumbers
              </ion-label>
            </ion-col>
            <ion-col class="p">
              <ion-label [color]="passLength ? 'success' : 'danger'" class="error-input" translate> common.passwordMinLength </ion-label>
            </ion-col>
          </ion-row>

          <ion-item class="full-width">
            <ion-label position="floating" translate>common.newPassword</ion-label>
            <ion-input
              autocomplete="off"
              [type]="showRepeatPassword ? 'text' : 'password'"
              [(ngModel)]="repeatPassword"
              (ionChange)="checkDiff()"
              clear-on-edit="false"></ion-input>

            <ion-icon
              [name]="showRepeatPassword ? 'eye' : 'eye-off'"
              class="eye-icon"
              color="medium"
              (click)="showRepeatPassword = !showRepeatPassword"></ion-icon>
          </ion-item>
          <ion-col class="p">
            <ion-label [color]="diffError ? 'success' : 'danger'" class="error-input" translate> common.diffPassword </ion-label>
          </ion-col>
        </div>
        <div class="lov center p">
          <ion-button
            class="j-button profile-button"
            expand="block"
            (click)="changePassword()"
            [hidden]="!changePass"
            [disabled]="!uppercase || !passLength || !characterSpecial || !characterNumbers || !diffError || newPassword !== repeatPassword"
            *ngIf="btnEnabled && !loading"
            translate
            >common.changePassword
          </ion-button>
        </div>
      </div>

      <ion-button class="j-button profile-button" *ngIf="!btnEnabled" expand="block">
        <ion-spinner name="crescent"></ion-spinner>
      </ion-button>
    </div>
  </div>
</ion-content>
